<script setup>
// // Component imports
import BarcodeQr from '@/components/BarcodeQr/BarcodeQrComp.vue';

const props = defineProps({
  goodsData: {
    type: Array,
    // required: true,
    default: () => [
      {
        productUuid: '',
        productSku: '',
        productUrl: '',
        productImages: [
          {
            productImageSrc: '',
            // productImageWidth: '',
            // productImageHeight: '',
          },
        ],
        productName: '',
        productPosition: 1,
      },
    ],
  },
  interactiveBreakUuid: {
    type: String,
    default: '',
  },
  adId: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <div v-for="item in props.goodsData" :key="item.productPosition" class="pbl-goods">
    <div class="pbl-goods__frame">
      <!-- <div
        class="pbl-goods__mat wave-right-left-effect"
        :class="`wave-right-left-effect--${item.productPosition}`"
      > -->
      <div class="pbl-goods__mat">
        <img
          class="pbl-goods__product kenBurnsEffect"
          :class="`pbl-goods__animation-delay--${item.productPosition}`"
          :src="item.productImages[0].productImageSrc"
        />
      </div>
    </div>

    <div class="pbl-goods__info">
      <span class="pbl-goods__sku">SKU {{ item.productSku }}</span>

      <span class="pbl-goods__name">{{ item.productName }}</span>
    </div>

    <BarcodeQr
      class="pbl-goods__qr"
      :target-url="item.productUrl"
      :interactive-break-uuid="props.interactiveBreakUuid"
      :product-uuid="item.productUuid"
      :ad-id="props.adId"
    />
  </div>
</template>
